import color from "@constants/color";
import React from "react";
import { View, StyleSheet } from "react-native";

const LoadingComponent = ({ visible, children, style }) => {
  return visible ? children : <View style={[styles.placeholder, style]} />;
};

const styles = StyleSheet.create({
  placeholder: {
    backgroundColor: color.lightGrey,
    height: 20,
    borderRadius: 4,
  },
});

export default LoadingComponent;
